var exports = {
  "kL": "xe533113f--b71c8d--container",
  "UU": "xe533113f--b71c8d--name",
};

module.exports = exports;
